import { Controller } from "@hotwired/stimulus";

/**
 * Collapsible Controller
 *
 * Simple toggle for showing/hiding content sections.
 * Defaults to collapsed. Pass `data-collapsible-open-value="true"` to start expanded.
 *
 * Usage:
 * <div data-controller="collapsible" data-collapsible-open-value="true">
 *   <button data-action="click->collapsible#toggle" data-collapsible-target="button">
 *     <span data-collapsible-target="showText">View policy</span>
 *     <span data-collapsible-target="hideText" class="hidden">Hide policy</span>
 *   </button>
 *   <div data-collapsible-target="content">
 *     Content here...
 *   </div>
 * </div>
 */
export default class extends Controller {
  static targets = ["content", "button", "showText", "hideText", "icon"];
  static values = { open: { type: Boolean, default: false } };

  connect() {
    // Apply initial state from openValue
    if (this.openValue) {
      this.show();
    } else {
      this.hide();
    }
  }

  toggle(event) {
    event.preventDefault();

    if (this.hasContentTarget) {
      const isHidden = this.contentTarget.classList.contains("hidden");

      if (isHidden) {
        this.show();
      } else {
        this.hide();
      }
    }
  }

  show() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("hidden");
    }

    // Toggle text visibility
    this.showTextTargets.forEach((el) => el.classList.add("hidden"));
    this.hideTextTargets.forEach((el) => el.classList.remove("hidden"));

    // Rotate icon if present
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180");
    }
  }

  hide() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("hidden");
    }

    // Toggle text visibility
    this.showTextTargets.forEach((el) => el.classList.remove("hidden"));
    this.hideTextTargets.forEach((el) => el.classList.add("hidden"));

    // Reset icon rotation
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180");
    }
  }
}
